import { render, staticRenderFns } from "./template.pug?vue&type=template&id=6405ea28&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style.sass?vue&type=style&index=0&id=6405ea28&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405ea28",
  null
  
)

export default component.exports